export const FR_LOCALE = 'fr';
export const EN_LOCALE = 'en';
export const ES_LOCALE = 'es';

export const AMPLIFY_FR_LOCALE = 'fr-FR';
export const AMPLIFY_EN_LOCALE = 'en-US';
export const AMPLIFY_ES_LOCALE = 'es-ES';

export type LocalesType = typeof FR_LOCALE | typeof EN_LOCALE | typeof ES_LOCALE;

export const LOCALES: { name: string; local: LocalesType }[] = [
  { name: 'Français', local: FR_LOCALE },
  { name: 'Español', local: ES_LOCALE },
  { name: 'English', local: EN_LOCALE },
];
